export default __webpack_public_path__ + "static/media/img_8.8729e743.JPG";